var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBothDoorsClosed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 21.34C12.75 21.8923 13.1977 22.34 13.75 22.34H18.75C20.5449 22.34 22 20.8849 22 19.09V5.58997C22 3.79504 20.5449 2.33997 18.75 2.33997H13.75C13.1977 2.33997 12.75 2.78768 12.75 3.33997L12.75 21.34ZM15 10.34C14.4477 10.34 14 10.7877 14 11.34V13.34C14 13.8923 14.4477 14.34 15 14.34C15.5523 14.34 16 13.8923 16 13.34V11.34C16 10.7877 15.5523 10.34 15 10.34Z",
    fill: "#222729"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 3.33997C11.25 2.78768 10.8023 2.33997 10.25 2.33997H5.25C3.45507 2.33997 2 3.79504 2 5.58997V19.09C2 20.8849 3.45507 22.34 5.25 22.34H10.25C10.8023 22.34 11.25 21.8923 11.25 21.34L11.25 3.33997ZM8 11.34C8 10.7877 8.44772 10.34 9 10.34C9.55228 10.34 10 10.7877 10 11.34V13.34C10 13.8923 9.55228 14.34 9 14.34C8.44772 14.34 8 13.8923 8 13.34V11.34Z",
    fill: "#222729"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBothDoorsClosed);
export default __webpack_public_path__ + "static/media/icon-both-doors-closed.bd062087c1ba732f25ed7b72673a41eb.svg";
export { ForwardRef as ReactComponent };